import { useEffect, useState } from 'react'

import { ReactComponent as ChevronDown } from 'assets/icons/chevron-down.svg'
import { Flex } from 'components/common/flex/Flex'
import { Icon } from 'components/common/Icon/Icon'
import { Typography } from 'components/common/Typography/Typography'

import styles from './AccordionHeader.module.scss'

export interface AccordionHeaderProps {
  title: string
  expanded?: boolean
  onClick?: () => void
  slot?: string
}

export const AccordionHeader = (props: AccordionHeaderProps) => {
  const { title, expanded = false, onClick, slot } = props

  const [isExpanded, setIsExpanded] = useState(expanded)

  useEffect(() => {
    setIsExpanded(expanded)
  }, [expanded])

  const handleAccordionItemClick = () => {
    setIsExpanded(!isExpanded)
    onClick && onClick()
  }

  return (
    <>
      <Flex
        justify="between"
        slot={slot}
        onClick={handleAccordionItemClick}
        style={{ cursor: 'pointer', width: '100%' }}
        className={styles.accordionHeader}
      >
        <Typography type="l-strong" className={styles.accordionTitle}>
          {title}
        </Typography>
        <Icon icon={ChevronDown} className={`${isExpanded ? styles.rotateUp : styles.rotateDown}`} color="#8b919a" />
      </Flex>
    </>
  )
}
